// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__36oSa","Logo":"Toolbar_Logo__1Dp4Y","DesktopOnly":"Toolbar_DesktopOnly__3nMx2"};